// 外呼呼叫相关功能
import { getMyAccount } from '@/api/member'

export const state = () => {
  return {
    // 是否是编辑状态
    isEdit: false,
    // 编辑中的话术信息
    editFlowInfo: {
      talkFlow: {
        nodes: [],
        transitions: [],
      },
    },
    // 编辑弹窗是否显示
    editDialogVisible: false,
    // 编辑中的节点信息, 如果有id则显示, 如果没有就隐藏
    editNodeInfo: {
      id: '',
      name: '',
      script: '',
      nodeIndex: '',
      left: 0,
      top: 0,
    },
  }
}

export const actions = {}

export const mutations = {
  // 设置是否是编辑状态
  setIsEdit(state, isEdit) {
    console.log('setIsEdit', isEdit)
    state.isEdit = isEdit
  },
  // 设置编辑节点信息
  setEditFlowInfo(state, editFlowInfo) {
    state.editFlowInfo = editFlowInfo
  },
  // 设置编辑弹窗是否显示
  setEditDialogVisible(state, editDialogVisible) {
    console.log('setEditDialogVisible', editDialogVisible)
    state.editDialogVisible = editDialogVisible
  },
  // 设置编辑节点信息
  setEditNodeInfo(state, editNodeInfo) {
    console.log('setEditNodeInfo', editNodeInfo)
    state.editNodeInfo = editNodeInfo
  },
}
export const getters = {
  isEdit: (state) => state.isEdit,
  editFlowInfo: (state) => state.editFlowInfo,
  editNodeInfo: (state) => state.editNodeInfo,
  editDialogVisible: (state) => state.editDialogVisible,
}
